import * as ApiHelper from "~/common/utils/ApiHelper";
import { resolveApiUrl } from "~/utils/url/urlResolver";

const apiUrl = resolveApiUrl("/bulkupload/clearMergeCart");
export function apiClearMergeCartData(): Promise<unknown> {
  const params: RequestInit = {
    cache: "no-cache",
    credentials: "same-origin",
    mode: "cors",
    method: "POST",
    headers: {
      CSRFToken: ApiHelper.getCsrfValue(),
    },
    redirect: "follow",
  };

  return fetch(apiUrl, params);
}
